import StudentPanelsConfig from '../../student-container/student-panels.config';

const PostsecConfig = {
  title: StudentPanelsConfig.POSTSECONDARY.human,
};

export default PostsecConfig;
